import React from 'react'
import PropTypes from 'prop-types'

import { CardContainer } from './styles'

const CharacteristicCard = ({
  onClick,
  children,
  className,
  style,
}) => (
  <CardContainer style={style} onClick={onClick} className={className}>
    {children}
  </CardContainer>
)

CharacteristicCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  className: PropTypes.string,
}

CharacteristicCard.defaultProps = {
  children: {},
  style: null,
  onClick: null,
  className: '',
}

export default CharacteristicCard
